import { z } from "zod";
import { ResponseGetCdtTreeSchema } from "@CommonApi/cdt/trees/_treeId_/index";

export const RouteGetCdtCategories_categoryId_Tree = "/cdt/categories/:categoryId/tree";

export const ParamsCdtCategoryTreeSchema = z.object({
  categoryId: z.coerce.number().int().positive(),
});

export type ParamsCdtCategoryTree = z.infer<typeof ParamsCdtCategoryTreeSchema>;
export type ResponseGetCdtCategoryTree = z.infer<typeof ResponseGetCdtTreeSchema>;
